// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + "about" + "." + "03282d93" + ".js";
};